import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPersist from "pinia-plugin-persistedstate";
import App from './App.vue'
import { i18n } from "./i18n";
import { router } from "@/routes/index";
import PhosphorIcons from "@phosphor-icons/vue"

import RowBox from "@/components/layout/RowBox.vue";
import ColumnBox from "@/components/layout/ColumnBox.vue";
import Spacer from "@/components/layout/Spacer.vue";

const isTouchDevice =
  window.matchMedia?.("(hover: none) and (pointer: coarse)")?.matches ||
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
const isAndroidDevice = /Android/i.test(navigator.userAgent);

if (isTouchDevice) {
  document.body.classList.add("mobile-no-select");
}
if (isAndroidDevice) {
  document.body.classList.add("android-webview");
}

const pinia = createPinia()
pinia.use(piniaPersist);
const app = createApp(App);
app.use(router);              // 라우터 사용
app.use(pinia)
app.use(PhosphorIcons)

app.component("RowBox", RowBox);
app.component("ColumnBox", ColumnBox);
app.component("Spacer", Spacer);
app.use(i18n).mount("#app");
